export default function removeUnwantedQueryParams(params: URLSearchParams) {
  if (params.has("origin")) {
    params.delete("origin");
  }
  if (params.has("page")) {
    params.delete("page");
  }
  return params;
}
